export enum PolicyDispositionTypes {
    POSITIVE = "positive",
    NEGATIVE = "negative"
}